// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeletePerformanceReviewMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type DeletePerformanceReviewMutation = { __typename?: 'Mutation' } & Pick<
  Types.Mutation,
  'deletePerformanceReview'
>;

export const DeletePerformanceReviewDocument = /*#__PURE__*/ gql`
    mutation DeletePerformanceReview($id: ID!) {
  deletePerformanceReview(id: $id)
}
    `;
export type DeletePerformanceReviewMutationFn = Apollo.MutationFunction<
  DeletePerformanceReviewMutation,
  DeletePerformanceReviewMutationVariables
>;

/**
 * __useDeletePerformanceReviewMutation__
 *
 * To run a mutation, you first call `useDeletePerformanceReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePerformanceReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePerformanceReviewMutation, { data, loading, error }] = useDeletePerformanceReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePerformanceReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<DeletePerformanceReviewMutation, DeletePerformanceReviewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeletePerformanceReviewMutation, DeletePerformanceReviewMutationVariables>(
    DeletePerformanceReviewDocument,
    options,
  );
}
export type DeletePerformanceReviewMutationHookResult = ReturnType<typeof useDeletePerformanceReviewMutation>;
export type DeletePerformanceReviewMutationOptions = Apollo.BaseMutationOptions<
  DeletePerformanceReviewMutation,
  DeletePerformanceReviewMutationVariables
>;
